import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';

export default function About() {
  const teamMembers = [
    {
      name: "Jimmy",
      role: "Co-Founder & Detail Specialist",
      description: "Passionate about perfection in every detail"
    },
    {
      name: "Axl",
      role: "Co-Founder & Operations Manager", 
      description: "Ensures every customer gets exceptional service"
    },
    {
      name: "Fabi",
      role: "Co-Founder & Quality Control",
      description: "Makes sure every car meets our high standards"
    }
  ];

  const values = [
    {
      icon: 'ri-heart-line',
      title: 'Passion-Driven',
      description: 'We genuinely love what we do and it shows in every detail'
    },
    {
      icon: 'ri-star-line',
      title: 'Quality First',
      description: 'Every car gets our full attention and best effort'
    },
    {
      icon: 'ri-team-line',
      title: 'Young & Energetic',
      description: 'Fresh perspective with unlimited enthusiasm'
    },
    {
      icon: 'ri-shield-check-line',
      title: 'Reliable Service',
      description: 'Professional results you can count on'
    }
  ];

  return (
    <div className="min-h-screen bg-white">
      <Header />
      
      {/* Hero Section */}
      <section 
        className="relative min-h-[60vh] flex items-center bg-cover bg-center"
        style={{
          backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.6), rgba(0, 0, 0, 0.6)), url('https://static.readdy.ai/image/e88ada64db3193888b9a84ae586990c8/10f6ab2f3082196e83d76417142950f9.jpeg')`
        }}
      >
        <div className="w-full max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center text-white">
            <h1 className="text-4xl md:text-6xl font-bold mb-6 leading-tight">
              About Total Care Detailing
            </h1>
            <p className="text-xl md:text-2xl max-w-3xl mx-auto">
              Three passionate thirteen-year-olds bringing professional detailing to North Carolina
            </p>
          </div>
        </div>
      </section>

      {/* Our Story */}
      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="max-w-4xl mx-auto text-center">
            <h2 className="text-3xl md:text-4xl font-bold text-black mb-8">
              Our Story
            </h2>
            <div className="text-lg text-black leading-relaxed space-y-6">
              <p>
                We're not your typical detailing company. Total Care Detailing was founded by three thirteen-year-old entrepreneurs who share an incredible passion for cars and delivering exceptional service. What started as a hobby quickly grew into a professional mobile detailing business serving Charlotte, Mooresville, and the surrounding areas.
              </p>
              <p>
                Despite our young age, we take our work seriously. We've invested in professional-grade equipment, studied the best techniques, and committed ourselves to providing results that rival any established detailing service. Our youth brings fresh energy, attention to detail, and a genuine excitement for every project we take on.
              </p>
              <p>
                We believe that passion and dedication matter more than years of experience. Every car we detail receives our complete focus and care, because we're not just building a business – we're pursuing our dreams and proving that age is just a number when you're truly committed to excellence.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Meet the Team */}
      <section className="py-20 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-3xl md:text-4xl font-bold text-black mb-4">
              Meet Our Team
            </h2>
            <p className="text-xl text-black">
              Three friends united by a shared passion for automotive excellence
            </p>
          </div>
          
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            {teamMembers.map((member, index) => (
              <div key={index} className="bg-white rounded-xl p-8 shadow-lg text-center">
                <div className="w-20 h-20 flex items-center justify-center bg-red-100 rounded-full mx-auto mb-6">
                  <i className="ri-user-line text-3xl text-red-600"></i>
                </div>
                <h3 className="text-xl font-semibold text-black mb-2">{member.name}</h3>
                <p className="text-red-600 font-medium mb-4">{member.role}</p>
                <p className="text-black">{member.description}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Our Values */}
      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-3xl md:text-4xl font-bold text-black mb-4">
              What Drives Us
            </h2>
            <p className="text-xl text-black">
              The values that guide everything we do
            </p>
          </div>
          
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
            {values.map((value, index) => (
              <div key={index} className="text-center">
                <div className="w-16 h-16 flex items-center justify-center bg-red-100 rounded-full mx-auto mb-6">
                  <i className={`${value.icon} text-2xl text-red-600`}></i>
                </div>
                <h3 className="text-xl font-semibold text-black mb-3">{value.title}</h3>
                <p className="text-black">{value.description}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Why Choose Young Entrepreneurs */}
      <section className="py-20 bg-black text-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="max-w-4xl mx-auto text-center">
            <h2 className="text-3xl md:text-4xl font-bold mb-8">
              Why Choose Young Entrepreneurs?
            </h2>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-8 text-left">
              <div className="space-y-4">
                <div className="flex items-start">
                  <div className="w-6 h-6 flex items-center justify-center mr-4 mt-1">
                    <i className="ri-check-line text-red-600"></i>
                  </div>
                  <div>
                    <h4 className="font-semibold mb-2">Unlimited Energy</h4>
                    <p className="text-gray-300">We bring fresh enthusiasm to every job</p>
                  </div>
                </div>
                <div className="flex items-start">
                  <div className="w-6 h-6 flex items-center justify-center mr-4 mt-1">
                    <i className="ri-check-line text-red-600"></i>
                  </div>
                  <div>
                    <h4 className="font-semibold mb-2">Attention to Detail</h4>
                    <p className="text-gray-300">We notice things others might miss</p>
                  </div>
                </div>
              </div>
              <div className="space-y-4">
                <div className="flex items-start">
                  <div className="w-6 h-6 flex items-center justify-center mr-4 mt-1">
                    <i className="ri-check-line text-red-600"></i>
                  </div>
                  <div>
                    <h4 className="font-semibold mb-2">Competitive Pricing</h4>
                    <p className="text-gray-300">Quality service at affordable rates</p>
                  </div>
                </div>
                <div className="flex items-start">
                  <div className="w-6 h-6 flex items-center justify-center mr-4 mt-1">
                    <i className="ri-check-line text-red-600"></i>
                  </div>
                  <div>
                    <h4 className="font-semibold mb-2">Personal Touch</h4>
                    <p className="text-gray-300">Every customer matters to us</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Call to Action */}
      <section className="py-20 bg-red-600 text-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <div className="w-16 h-16 flex items-center justify-center bg-white rounded-full mx-auto mb-6">
            <i className="ri-message-3-fill text-3xl text-red-600"></i>
          </div>
          <h2 className="text-3xl md:text-4xl font-bold mb-4">Ready to Experience the Difference?</h2>
          <p className="text-xl mb-8 max-w-2xl mx-auto">
            To book, text 980-261-1286 and we'll give you a quote
          </p>
          <a 
            href="sms:+19802611286" 
            className="inline-block bg-white text-red-600 hover:bg-black hover:text-white font-semibold rounded-lg transition-colors duration-200 cursor-pointer whitespace-nowrap px-10 py-4 text-lg"
          >
            Text Us Now
          </a>
        </div>
      </section>

      <Footer />
    </div>
  );
}